var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-span-1 sm:col-span-2"},[_c('hr',{staticClass:"m-0"})])
}]

export { render, staticRenderFns }